import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function PageHero({ eyebrow, title, subtitle, crumbs = [] }) {
  return (
    <section className="bg-navy grain relative overflow-hidden" data-testid="page-hero">
      <div className="absolute inset-0 opacity-10 bg-gradient-to-br from-mutedblue to-transparent" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <nav className="flex items-center gap-1.5 text-xs text-slate-400 mb-5" data-testid="breadcrumbs">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-1.5">
              <ChevronRight className="h-3 w-3" />
              {c.to ? <Link to={c.to} className="hover:text-white transition-colors">{c.label}</Link> : <span className="text-slate-300">{c.label}</span>}
            </span>
          ))}
        </nav>
        {eyebrow && (
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-8 bg-gold" /><span className="eyebrow text-gold">{eyebrow}</span>
          </div>
        )}
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-white leading-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-4 text-slate-300 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
